import {
  Configuration,
  FeatureFlagsApi,
  type ResponseFeatureSettings,
} from '@/infrastructure/api/client_typescript';
import { TokenStore } from '@/infrastructure/storage/TokenStore';

export class FeatureFlagsService {
  private featureFlagsApi: FeatureFlagsApi;

  constructor(apiBaseUrl: string, tokenStore: TokenStore) {
    const config = new Configuration({
      basePath: apiBaseUrl,
      accessToken: () => tokenStore.getAccess() || '',
    });
    this.featureFlagsApi = new FeatureFlagsApi(config);
  }

  async getFeatureFlags(): Promise<ResponseFeatureSettings> {
    const response = await this.featureFlagsApi.getFeatureFlags();
    return response.data;
  }
}
